/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { shared_FlexibleDate } from './shared_FlexibleDate';
export type billing_DiscountRequest = {
    /**
     * Category of discount (weekday, custom)
     */
    category: billing_DiscountRequest.category;
    /**
     * Reason for the discount
     */
    reason: string;
    /**
     * Type of discount (percentage or fixed)
     */
    type: billing_DiscountRequest.type;
    /**
     * ValidFrom date for the discount
     */
    valid_from?: shared_FlexibleDate;
    /**
     * ValidUntil date for the discount
     */
    valid_until?: shared_FlexibleDate;
    /**
     * Value of the discount. A custom fixed amount may be NEGATIVE — that is a
     * surcharge that adds to the parent total (see ValidateDiscountRequest for
     * the per-type/category sign rules). `required` still rejects an exact 0.
     */
    value: number;
    /**
     * Weekday (1=Monday, 7=Sunday) - required when Category is "weekday"
     */
    weekday?: number;
};
export namespace billing_DiscountRequest {
    /**
     * Category of discount (weekday, custom)
     */
    export enum category {
        WEEKDAY = 'weekday',
        CUSTOM = 'custom',
    }
    /**
     * Type of discount (percentage or fixed)
     */
    export enum type {
        PERCENTAGE = 'percentage',
        FIXED = 'fixed',
    }
}

